import React from 'react';
import { DocumentPickerFooterProps } from '~/src/types/clioDocumentPicker';
import Button from '~/src/components/Button';

export const DocumentPickerFooter: React.FC<DocumentPickerFooterProps> = ({
  selectedItems,
  onCancel,
  onConfirm,
  isLoading,
  isDownloading = false,
}) => {
  return (
    <div className="px-6 py-4 border-t border-gray-200 bg-white">
      <div className="flex items-center justify-end">
        {/* Action buttons */}
        <div className="flex items-center gap-3">
          <Button onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            primary
            onClick={onConfirm}
            disabled={selectedItems.length === 0 || isLoading}
          >
            {isDownloading
              ? `Downloading ${selectedItems.length} file${
                  selectedItems.length > 1 ? 's' : ''
                }...`
              : isLoading
              ? 'Loading...'
              : `Add files (${selectedItems.length})`}
          </Button>
        </div>
      </div>
    </div>
  );
};
